/*
 *   File : password-input.js
 *   Author : https://evoqins.com
 *   Description : Password Input component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React, { memo, useState, useRef } from "react";

//custom style
// import styles from "../../Style/Components/input.module.scss";

// Assets
import showIcon from "../../Assets/Image/show.svg";
import hideIcon from "../../Assets/Image/hide.svg";

const CustomPasswordInput = (props) => {
  const inputRef = useRef(null);
  // const [isInputFocused, setIsInputFocused] = useState(false);
  const [show, setShow] = useState(false);

  //handle focus
  // const _handleFocus = () => {
  //   setIsInputFocused(true);
  // };

  // const _handleBlur = () => {
  //   setIsInputFocused(false);
  // };

  //input handle change
  const _handleChange = (e) => {
    let value = e.target.value;
    props.handleChange(value);

    // const masked_password = e.target.value.replace(/./g, '*');
    // props.handleChange(masked_password);
  };

  // handle enter key press
  const _keyPress = (e) => {
    if (e.keyCode === 13) {
      props.onKeyPress();
    }
  };

  // handle show and hide password
  const _handleShow = () => {
    setShow(!show);
    if (inputRef.current) {
      setTimeout(() => {
        inputRef.current.focus();
        inputRef.current.setSelectionRange(
          inputRef.current.value.length,
          inputRef.current.value.length
        );
      }, 0);
    }
  };

  return (
    <div>
      {props.label && (
        <label
          className={`${
            props.labelStyle
              ? props.labelStyle
              : "  e-font-weight-500  e-font-14"
          } e-text-black e-primary-font-poppins pb-1`}
        >
          {props.label}
          {props.require && <span className="text-danger">*</span>}
        </label>
      )}

      <div className="h-64px">
        <div className={`position-relative`}>
          <input
            id={props.id}
            ref={inputRef}
            value={props.value}
            defaultValue={props.defaultValue}
            maxLength={props.maxLength}
            tabIndex={props.tabIndex}
            autoFocus={props.autoFocus}
            type={show ? "text" : "password"}
            required={props.required}
            readOnly={props.readOnly}
            placeholder={props.placeholder}
            className={`${props.error && "e-border-1px-ruby"} ${
              props.className
            } p-3 e-input-element bg-white e-font-weight-400 e-primary-font-poppins`}
            onWheel={() => document.activeElement.blur()}
            // onFocus={_handleFocus}
            // onBlur={_handleBlur}
            onChange={_handleChange}
            onKeyDown={(e) => _keyPress(e)}
            onClick={props.onClick}
          />

          <img
            src={show ? showIcon : hideIcon}
            draggable={false}
            className="e-cursor-pointer position-absolute top-16px right-16px w-24px"
            width={18}
            alt="icon"
            onClick={_handleShow}
          />
        </div>
        {/* error message */}
        {props.error && (
          <p className="mb-0 e-font-12 text-danger e-primary-font-poppins  pt-1">
            {props.error}
          </p>
        )}
      </div>
    </div>
  );
};

CustomPasswordInput.defaultProps = {
  onKeyPress: () => {},
  className: null,
  error: "",
};

export default memo(CustomPasswordInput);
